"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_24anj93aaa() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateCheckedFilled.tsx";
  var hash = "97a961fe3b2f6302e45ae6012f9c9fa7af0050dc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateCheckedFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 59
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "97a961fe3b2f6302e45ae6012f9c9fa7af0050dc"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_24anj93aaa = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_24anj93aaa();
var Icon = (cov_24anj93aaa().s[0]++, {
  name: 'date-checked-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.5 1.75C8.19036 1.75 8.75 2.30964 8.75 3V5H15.25V3C15.25 2.30964 15.8096 1.75 16.5 1.75C17.1904 1.75 17.75 2.30964 17.75 3V5H19C20.6569 5 22 6.34315 22 8V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V8C2 6.34315 3.34315 5 5 5H6.25V3C6.25 2.30964 6.80964 1.75 7.5 1.75ZM10.5 17.768L16.7678 11.5002L15 9.73242L10.5 14.2324L9.00001 12.7324L7.23224 14.5002L10.5 17.768Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;